//DIDSection3_1

// src/components/DIDSection3_1.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;

  align-items: center;
  padding:5% 0% 0% 0%; 
  background-color: #000000; /* 调整背景颜色根据需要 */
  width:60%;
  margin: 0 auto;

  @media (max-width: 500px) {
    flex-direction: column; /* 在小于500px时，垂直排列 */
    padding: 10% 0% 0% 0%;
    width:90vw;
  }
`;

const LeftColumn = styled.div`
  flex: 4;
  
  @media (max-width: 500px) {

    width:100vw;
    text-align: center;
    
  }
  
`;

const Image = styled.img`
  width: 110%;
  height: auto;


  @media (max-width: 500px) {

    width: 90vw;
    height:auto;
    
    
    
  }
`;



const RightColumn = styled.div`
  flex: 6; 
  width:60%;
  overflow: hidden;
  padding:0% 0% 0% 5%;

  @media (max-width: 500px) {
    
    width:100%;
    padding:0% 0% 10% 0% ;

  }
  
`;

const GroupContainer = styled.div`
  margin-bottom: 2.5%; 
  margin-left: 2.5%; 

  padding:1%;

  @media (max-width: 500px) {
    width:100%;
    margin:0 auto;
   
    padding:0%;

  }
`;

const GroupTitle = styled.h3`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  margin-bottom: 1%;
  margin-top: 1%; 
  color: #FFFFFF;
  padding:0% 0% 0% 0%;


  p{

    font-size: 18px;
    line-height: 32px;
    color: #AFAFAF;
    padding:0% 0% 3% 0%;
  }

  @media (max-width: 500px) {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    padding:5% 0% 0% 2% ;

    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
  }

`;

const Button = styled.a`
  text-decoration: none;
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;

  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;

  
  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:0px;
    padding: 6px 20px;
    margin: 0 auto;


  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const DIDSection3_1 = () => {
  return (
    <SectionContainer>
      <LeftColumn>
        <Image src="/images/DIDSec3_1_1.png" alt="Image Title" />
      </LeftColumn>
      <RightColumn>
        <GroupContainer>
          <GroupTitle>DID 研究概括<p>涵蓋四大部分：分析國際分散式身分技術規格、探討web3產業中分散式身分的應用案例、針對臺灣的分散式身分進行探析及提出建議，以及對可溯源生成式AI服務的理解與解決方案。施行建議則包括選擇合適的分散式身分技術（建立管理、身分容器、憑證）、在地情境的盤點與分析，以及施行初步階段的建議。</p></GroupTitle>
          <Button href="https://drive.google.com/file/d/1gWWYhE9pMotIQVzyXtKTwAJvr7KOm--A/view?usp=sharing" target="_blank" style={{ textDecoration: 'none' }}>閱讀更多</Button>
         
        </GroupContainer>
        
      </RightColumn>

    </SectionContainer>
    

  );
};

export default DIDSection3_1;
